import _extends from "@babel/runtime/helpers/esm/extends";
const accentBlue = {
  900: '#006894',
  // $color-accent-blue-01-dark
  800: '#007eb4',
  // $color-accent-blue
  700: '#0b8ec6',
  // $color-accent-blue-03-light
  600: '#20a0d6',
  // $color-accent-blue-04-light
  500: '#41b2e3',
  // $color-accent-blue-05-light
  400: '#6cc6ed',
  // $color-accent-blue-06-light
  300: '#99d9f5',
  // $color-accent-blue-07-light
  200: '#c1e9fa',
  // $color-accent-blue-08-light
  100: '#ddf3fd',
  // $color-accent-blue-09-light
  50: '#eefaff',
  //  $color-accent-blue-10-light
  25: '#f5fcff' //  $color-accent-blue-11-light
};

const secondary = _extends({}, accentBlue, {
  dark: accentBlue[900],
  //  $color-accent-blue-01-dark
  main: accentBlue[800],
  //  $color-accent-blue
  light: accentBlue[700],
  // $color-core-blue-03-light
  contrastText: '#ffffff'
});
export default secondary;